import { DescriptionList_Content_default } from "./chunk-72PTV7QL.js";
import { DescriptionList_Title_default } from "./chunk-O6GV4JG3.js";
import { DescriptionList_default } from "./chunk-YWETHHT5.js";

// src/elements/DescriptionList/index.ts
var DescriptionListComponent = DescriptionList_default;
DescriptionListComponent.Title = DescriptionList_Title_default;
DescriptionListComponent.Title.displayName = "DescriptionList.Title";
DescriptionListComponent.Content = DescriptionList_Content_default;
DescriptionListComponent.Content.displayName = "DescriptionList.Content";
export { DescriptionListComponent };